<template>
  <div class="bg-gray-100">
    <div class=" max-w-7xl mx-auto sm:px-6 lg:px-8">
        <h2 class="font-semibold text-lg text-gray-800 leading-tight">
   {{headerTitle}}
        </h2>
     
        
        </div>

  </div>


</template>

<script>
export default {
    props: {
          headerTitle:String,
          headers:Array,
        },
};
</script>

<style>
.text-lg{
margin-bottom: 0.05rem;
}
</style>